<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$(function() {
$('.rb-accordion-main .rb-accordion').click(function(event){
  event.stopPropagation();
  
  $(this).toggleClass('active');
  $(this).siblings().removeClass('active');
  
  $('.rb-accordion-body').stop().slideUp();
  $('.rb-accordion-main .rb-accordion.active .rb-accordion-body').stop().slideDown();
  
  return false;
});

$('.rb-accordion-body').click(function(event){
  event.stopPropagation();
});  $('.review-slider').slick({
  dots: true,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }

  ]
});
});

				